module.exports = __webpack_public_path__ + "img/nyeremenyek.125069e4.png";